import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Button } from '@shared';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lib-table-functions',
  imports: [
    Button,
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgClass,
  ],
  templateUrl: './table-functions.html',
  styleUrl: './table-functions.scss',
  providers: [provideNativeDateAdapter()],
})
export class TableFunctions {
  @Input() showSearch: boolean = false;
  @Input() searchPlaceholder: string = 'Search...';
  @Input() showStatus: boolean = false;
  @Input() showDateFilter: boolean = false;
  @Input() showRangeFilter: boolean = false;
  @Output() dateRangeChange = new EventEmitter<{
    startDate: Date | null;
    endDate: Date | null;
  }>();
  @Output() dateChange = new EventEmitter<{
    startDate: Date | null;
  }>();

  startDate: Date | null = null;
  endDate: Date | null = null;

  @Output() search = new EventEmitter();
  searchText: string = '';

  onSearch() {
    this.search.emit(this.searchText);
  }

  onClear() {
    this.searchText = '';
    this.search.emit(this.searchText);
  }

  onClearDate() {
    this.startDate = null;
    this.endDate = null;
    try {
      this.showDateFilter ? this.dateChange.emit() : this.dateRangeChange.emit();
    } catch (error) {
      console.error('Error clearing date:', error);
    }
  }

  onDateChange() {
    this.dateChange.emit({
      startDate: this.startDate,
    });
  }

  onDateRangeChange() {
    if (this.startDate && this.endDate) {
      this.dateRangeChange.emit({
        startDate: this.startDate,
        endDate: this.endDate,
      });
    }
  }
}
